import React from "react";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import { InspectionStatus, InspectionStatuses } from "../../citizen-inspection-list/constants/InspectionStatus";

interface InspectionPanelEllipsisPopupProps {
  onChangeLocationClick: () => void;
  onRescheduleClick: () => void;
  onDeleteClick: () => void;
  scheduled: boolean;
  status: InspectionStatus;
}
export default function InspectionPanelEllipsisPopup({
  onChangeLocationClick,
  onRescheduleClick,
  onDeleteClick,
  scheduled,
  status,
}: InspectionPanelEllipsisPopupProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      const listener = () => {
        handlePopupClose();
      };
      document.addEventListener("click", listener);

      return () => {
        document.removeEventListener("click", listener);
      };
    }
  }, [open]);

  const handlePopupOpen = () => {
    setOpen(true);
  };

  const handlePopupClose = () => {
    setOpen(false);
  };

  const handleChangeLocationClick = () => {
    handlePopupClose();
    onChangeLocationClick();
  };

  const handleRescheduleClick = () => {
    handlePopupClose();
    onRescheduleClick();
  };

  const handleDeleteClick = () => {
    handlePopupClose();
    onDeleteClick();
  };

  return (
    <Dropdown
      trigger={
        <Button onClick={handlePopupOpen} className='tw-px-2 tw-py-2' basic>
          <FontAwesomeIcon className='tw-grow' size='xl' icon={faEllipsis} />
        </Button>
      }
      size='large'
      icon={null}
    >
      <Dropdown.Menu>
        <Dropdown.Item>
          <div role='button' tabIndex={-1} onClick={handleChangeLocationClick}>
            Change Location...
          </div>
        </Dropdown.Item>
        {status !== InspectionStatuses.PASSED && status !== InspectionStatuses.FAILED && (
          <Dropdown.Item>
            <div role='button' tabIndex={-1} onClick={handleRescheduleClick}>
              {scheduled ? "Reschedule" : "Schedule"}...
            </div>
          </Dropdown.Item>
        )}
        <Dropdown.Item>
          <div role='button' tabIndex={-1} className={` tw-text-red`} onClick={handleDeleteClick}>
            Delete...
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
